import {useEffect, useState} from 'react';
import { Space} from 'antd';
import cn from 'classnames';

import {Card} from '../../../components/Card/Card';
import { T2Button } from '../../../components/T2Button/T2Button';

import imgd from './vita-girl-blue.jpg'
import imgm from './vita-girl-mobile-blue.jpg'

import cls from './Cover.module.scss'

function getWindowDimensions() {
    const {innerWidth: width, innerHeight: height} = window;
    return {
        width,
        height
    };
}

export const Cover = () => {

    const [width, setWidth] = useState(getWindowDimensions().width);
    useEffect(() => {
        function handleResize() {
            setWidth(getWindowDimensions().width);
        }

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return (
        <div className={cn(['content', cls.wrapper])}>

            <Card
                className={cls.cover}
                style={{backgroundImage: `url(${width >= 1024 ? imgd : imgm })`}}
                bottom={<Card
                    color={'white'}
                    className={cls.card}
                    top={
                        <Space direction={'vertical'} size={8}>
                            <h1>Забота о&nbsp;здоровье</h1>
                            <div>
                                {width > 1024 ?
                                    <>Контролируйте свое здоровье, получайте рекомендации по&nbsp;чекапам, проконсультируйтесь у&nbsp;специалиста для улучшения качества своей жизни</>
                                    :
                                    <>Контролируйте свое здоровье, консультируйтесь со&nbsp;специалистами и&nbsp;получайте рекомендации</>
                                }
                            </div>
                            {width > 1024 && <p><span className={cls.price}>15</span> ₽/СУТ</p>}
                            <a href={'#connect'}><T2Button block>Подключить</T2Button></a>
                        </Space>
                    }
                />
                }
            />
        </div>
    )
}